import { apiRequest } from '@/services/module/ai-float'

export default class ScriptExecutor {
  _logs = []

  constructor(vue) {
    this.$route = vue.$route
    this.$router = vue.$router
    this.$store = vue.$store
    this.$message = vue.$message
  }

  logInfo(...args) {
    this._logs.push({
      args: args.map(a => {
        try {
          return typeof a === 'object' ? JSON.parse(JSON.stringify(a)) : String(a)
        } catch (_) {
          return String(a)
        }
      })
    })
  }

  requestApi(method, path, params) {
    return apiRequest(method, path, params)
  }

  async evalScript(script) {
    try {
      // eslint-disable-next-line no-eval
      const result = await window.Promise.resolve(eval(script))
      const jsonResult = result === null || result === undefined ? result : JSON.parse(JSON.stringify(result))
      return { logs: this._logs, result: jsonResult }
    } catch (e) {
      return { logs: this._logs, result: e.msg ?? e.message }
    }
  }
}
